// Module
var code = "<h2 id=\"lender-library\">Lender Library</h2> <p>Our Lender Library gives you access to commonly requested forms.</p> ";
// Exports
export default code;